import React, { useState } from 'react';
import { Stack, Text, DefaultButton } from '@fluentui/react';
import { ChecklistData } from '../types';
import IvicosStrings from 'kits/language/stringKit';
import TestConnection from './TestConnection';

interface Props {
    checklistData: ChecklistData;
    setChecklistData: React.Dispatch<React.SetStateAction<ChecklistData>>;
}

const ScreenshotsUpload: React.FC<Props> = ({ checklistData, setChecklistData }) => {
    const [showTestConnection, setShowTestConnection] = useState(false);

    const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files) {
            setChecklistData((prev) => ({
                ...prev,
                screenshots: [...prev.screenshots, ...Array.from(files)]
            }));
        }
    };

    return (
        <Stack tokens={{ childrenGap: 20 }} styles={{ root: { marginTop: 20 } }}>
            <DefaultButton onClick={() => setShowTestConnection(!showTestConnection)} style={{ width: 'fit-content' }}>
                {showTestConnection ? IvicosStrings.webRTCDiagnosticsShowTestEnvironment.hide : IvicosStrings.webRTCDiagnosticsShowTestEnvironment.show}
            </DefaultButton>

            {showTestConnection && <TestConnection />}

            <Stack tokens={{ childrenGap: 5 }}>
                <Text variant="large">{IvicosStrings.webRTCDiagnosticsScreenshotsTitle}</Text>
                <input type="file" accept="image/*" multiple onChange={handleUpload} />
                {checklistData.screenshots.length > 0 && (
                    <Text>
                        {checklistData.screenshots.length} {IvicosStrings.webRTCDiagnosticsScreenshotsCount}
                    </Text>
                )}
            </Stack>
        </Stack>
    );
};

export default ScreenshotsUpload;
